// src/components/PageRenderer.js
import React, { useEffect, useState } from 'react'; // useState and useEffect hinzufügen
import Header from './Header';
import SidebarLeft from './SidebarLeft';
import SidebarRight from './SidebarRight';
import Body from './Body';
import Footer from './Footer';
import Background from './Background';
import './PageLayout.css'; // NEU: CSS-Datei importieren
// Importiere den PageThemeContextProvider
import { PageThemeContextProvider } from './context/PageThemeContext';
import './UserCostum.css';

const sectionComponents = {
  'sections.header': Header,
  'sections.sidebar-left': SidebarLeft,
  'sections.sidebar-right': SidebarRight,
  'sections.body': Body,
  'sections.footer': Footer,
};

const PageRenderer = ({ sections, Background: pageBackgroundData }) => {
  // --- KORREKTUR: HOOKS AN DEN ANFANG VERSCHIEBEN ---
  // State, um die Bildschirmbreite zu verfolgen
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  // Effekt, um auf Größenänderungen zu reagieren
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // --- ENDE KORREKTUR ---

  if (!sections || sections.length === 0) {
    return <div>Keine Sektionen zum Anzeigen.</div>;
  }

  const hasHeader = sections.some(s => s.__component === 'sections.header');
  const hasSidebarLeft = sections.some(s => s.__component === 'sections.sidebar-left');
  const hasSidebarRight = sections.some(s => s.__component === 'sections.sidebar-right');
  const hasBody = sections.some(s => s.__component === 'sections.body');
  const hasFooter = sections.some(s => s.__component === 'sections.footer');

  // --- Dynamische Grid-Konfiguration ---
  let gridTemplateColumnsClass = '';
  let gridTemplateRows = '1fr';
  let contentStartRow = 1;

  if (isMobile) {
    gridTemplateRows = 'repeat(' + sections.length + ', auto)';
  } else {
    if (hasSidebarLeft && hasSidebarRight) {
      gridTemplateColumnsClass = 'grid-cols-two-sidebar';
    } else if (hasSidebarLeft) {
      gridTemplateColumnsClass = 'grid-cols-left-sidebar';
    } else if (hasSidebarRight) {
      gridTemplateColumnsClass = 'grid-cols-right-sidebar';
    } else {
      gridTemplateColumnsClass = 'grid-cols-no-sidebar';
    }

    if (hasHeader && hasFooter) {
      gridTemplateRows = 'auto 1fr auto';
      contentStartRow = 2;
    } else if (hasHeader && !hasFooter) {
      gridTemplateRows = 'auto 1fr';
      contentStartRow = 2;
    } else if (!hasHeader && hasFooter) {
      gridTemplateRows = '1fr auto';
    }
  }

  const contentEndRowSpan = hasFooter ? (contentStartRow + 1) : -1;
  const overallPageBackgroundColor = pageBackgroundData?.BackgroundColorHexCode;


  return (
      // Den PageThemeContextProvider hier um den gesamten Inhalt legen
    <PageThemeContextProvider overallPageBackgroundColor={overallPageBackgroundColor}>
    <div style={{ position: 'relative', minHeight: '100vh', width: '100vw', overflowX: 'hidden', margin: 0, padding: 0 }}>
      {pageBackgroundData && (
        <Background {...pageBackgroundData} zIndex={-2} />
      )}

      <div className={`page-grid-container ${gridTemplateColumnsClass}`} style={{
        gridTemplateRows: gridTemplateRows,
      }}>
        {sections.map((section, index) => {
          const Component = sectionComponents[section.__component];
          if (!Component) {
            console.warn(`Keine React-Komponente gefunden für: ${section.__component}`);
            return null;
          }

          let gridColumn = '';
          let gridRow = '';
          let renderThisSection = true;

          if (isMobile) {
            gridRow = (index + 1).toString();
            gridColumn = '1 / -1';
          } else {
            switch (section.__component) {
              case 'sections.header':
                if (!hasHeader) {
                  renderThisSection = false;
                } else {
                  gridColumn = '1 / -1';
                  gridRow = '1';
                }
                break;

              case 'sections.sidebar-left':
                if (!hasSidebarLeft) {
                  renderThisSection = false;
                } else {
                  if (hasSidebarLeft && hasSidebarRight) {
                    gridColumn = '1';
                  } else if (hasSidebarLeft && !hasSidebarRight) {
                    gridColumn = '1';
                  }
                  gridRow = `${contentStartRow} / ${contentEndRowSpan}`;
                }
                break;

              case 'sections.body':
                if (!hasBody) {
                  renderThisSection = false;
                } else {
                  if (hasSidebarLeft && hasSidebarRight) {
                    gridColumn = '2';
                  } else if (hasSidebarLeft) {
                    gridColumn = '2';
                  } else if (hasSidebarRight) {
                    gridColumn = '1';
                  } else {
                    gridColumn = '1';
                  }
                  gridRow = `${contentStartRow} / ${contentEndRowSpan}`;
                }
                break;

              case 'sections.sidebar-right':
                if (!hasSidebarRight) {
                  renderThisSection = false;
                } else {
                  if (hasSidebarLeft && hasSidebarRight) {
                    gridColumn = '3';
                  } else if (hasSidebarRight && !hasSidebarLeft) {
                    gridColumn = '2';
                  }
                  gridRow = `${contentStartRow} / ${contentEndRowSpan}`;
                }
                break;

              case 'sections.footer':
                if (!hasFooter) {
                  renderThisSection = false;
                } else {
                  gridColumn = '1 / -1';
                  gridRow = hasHeader ? '3' : '2';
                }
                break;

            default:
            renderThisSection = false;
            break;
            }
          }
if(section.__component==='sections.body' && section.BodyStyle === 'style5' && !isMobile){
         
            return renderThisSection ? (
            <div
            key={section.id}
            style={{
            gridColumn: gridColumn,
            gridRow: gridRow,
            maxWidth: 'calc(100% / 3 * 2)',
            marginLeft: 'auto',
            marginRight: 'auto',
            }}
            >
            <Component {...section} />
            </div>
            ) : null;
        }

           else{
           return renderThisSection ? (
           <div
           key={section.id}
           style={{
           gridColumn: gridColumn,
           gridRow: gridRow,
          }}
          >
          <Component {...section} />
          </div>
          ) : null;
        }
        })}
      </div>
    </div>
    </PageThemeContextProvider>
  );
};

export default PageRenderer;